export const SET_ELEMENT_OPACITY = 'SET_ELEMENT_OPACITY';
export const SET_ELEMENT_FILL = 'SET_ELEMENT_FILL';
export const SET_ELEMENT_COLOR = 'SET_ELEMENT_COLOR';
export const SET_ELEMENT_GRADIENT_TYPE = 'SET_ELEMENT_GRADIENT_TYPE';
export const SET_ELEMENT_GRADIENT_COLOR = 'SET_ELEMENT_GRADIENT_COLOR';
export const SET_ELEMENT_UNLOCKED_RATIO = 'SET_ELEMENT_UNLOCKED_RATIO';
export const SET_ELEMENT_FLIP_X = 'SET_ELEMENT_FLIP_X';
export const SET_ELEMENT_FLIP_Y = 'SET_ELEMENT_FLIP_Y';
export const SET_ELEMENT_TEXT_ALIGN = 'SET_ELEMENT_TEXT_ALIGN';
export const SET_ELEMENT_TEXT_BOLD = 'SET_ELEMENT_TEXT_BOLD';
export const SET_ELEMENT_TEXT_ITALIC = 'SET_ELEMENT_TEXT_ITALIC';
export const SET_ELEMENT_TEXT_FONT = 'SET_ELEMENT_TEXT_FONT';

export const SET_ELEMENT_IMAGE_RECOLOR = 'SET_ELEMENT_IMAGE_RECOLOR';
export const CLEAR_ELEMENT_IMAGE_RECOLOR = 'CLEAR_ELEMENT_IMAGE_RECOLOR';

export const setElementOpacity = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_OPACITY,
  scribeId,
  elementIds,
  update: {
    opacity: value
  }
});

export const setElementFill = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_FILL,
  scribeId,
  elementIds,
  update: {
    fill: value,
    backgroundType: 'solid'
  }
});

export const setElementGradientType = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_GRADIENT_TYPE,
  scribeId,
  elementIds,
  update: {
    backgroundGradientType: value
  }
});

export const setElementGradientColor = ({ scribeId, elementIds, value, position = 'from' }) => ({
  type: SET_ELEMENT_GRADIENT_COLOR,
  scribeId,
  elementIds,
  update: {
    backgroundType: 'gradient',
    [position === 'from' ? 'backgroundColorFrom' : 'backgroundColorTo']: value
  }
});

export const setElementUnlockedRatio = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_UNLOCKED_RATIO,
  scribeId,
  elementIds,
  update: {
    unlockedRatio: value
  }
});

export const setElementFlipX = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_FLIP_X,
  scribeId,
  elementIds,
  update: {
    flipX: value
  }
});

export const setElementFlipY = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_FLIP_Y,
  scribeId,
  elementIds,
  update: {
    flipY: value
  }
});

export const setElementTextAlign = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_TEXT_ALIGN,
  scribeId,
  elementIds,
  update: {
    align: value
  }
});

export const setElementTextBold = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_TEXT_BOLD,
  scribeId,
  elementIds,
  update: {
    fontWeight: value
  }
});

export const setElementTextItalic = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_TEXT_ITALIC,
  scribeId,
  elementIds,
  update: {
    fontStyle: value
  }
});

export const setElementTextFont = ({ scribeId, elementIds, value }) => ({
  type: SET_ELEMENT_TEXT_FONT,
  scribeId,
  elementIds,
  update: {
    font: value
  }
});

export const setElementImageRecolor = ({ scribeId, elementId, layer, value }) => ({
  type: SET_ELEMENT_IMAGE_RECOLOR,
  scribeId,
  elementId,
  layer,
  value
});

export const clearElementImageRecolor = ({ scribeId, elementId }) => ({
  type: CLEAR_ELEMENT_IMAGE_RECOLOR,
  scribeId,
  elementId
});
